import { fullImageUrl } from "@/lib/images";
import Placeholder from "./Placeholder";

/**
 * Renders a real photograph from an uploaded image, otherwise the elegant
 * placeholder. Keeps a consistent rounded-frame treatment across the site.
 */
export default function PhotoFrame({
  image,
  placeholderLabel,
  placeholderCaption,
  placeholderIcon,
  ratio = "aspect-[4/5]",
  className = "",
  tone = "light",
  index,
}) {
  const url = fullImageUrl(image);
  if (!url) {
    return (
      <Placeholder
        label={placeholderLabel}
        caption={placeholderCaption}
        icon={placeholderIcon}
        ratio={ratio}
        className={className}
        tone={tone}
        index={index}
      />
    );
  }
  return (
    <figure
      data-testid={`photo-${(image.placement || "image").toLowerCase()}-${image.id}`}
      className={`relative overflow-hidden rounded-2xl ${ratio} ${className} bg-[#EFEAE4] border border-[#2C392F]/10 group`}
    >
      <img
        src={url}
        alt={image.alt || image.caption || placeholderLabel || "ChiMano House"}
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1200ms] ease-[cubic-bezier(.22,1,.36,1)] group-hover:scale-[1.04]"
      />
      {image.caption && (
        <figcaption className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-[#1A1C1A]/70 via-[#1A1C1A]/20 to-transparent px-5 py-4">
          <span className="serif italic text-[#F7F5F0] text-base md:text-lg leading-snug">
            {image.caption}
          </span>
        </figcaption>
      )}
    </figure>
  );
}
